var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasMeasurement
    ? _c("div", { staticClass: "uxo-item__technical-information" }, [
        _c("h3", { staticClass: "mb-2" }, [_vm._v("Technical Information")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-block d-md-flex" }, [
          _c(
            "div",
            { staticClass: "technical-information mr-md-3 mb-2 mb-md-0" },
            [
              _c(
                "ul",
                { staticClass: "rows t-navy fs-18" },
                [
                  _vm._l(_vm.hazard.measurement, function(measurement, key) {
                    return [
                      measurement && key !== "measurement_unit"
                        ? _c(
                            "li",
                            { staticClass: "row px-2 py-12px t-navy w-100" },
                            [
                              _c("div", { staticClass: "column is-4 p-0" }, [
                                _vm._v(_vm._s(_vm.measurementTitle(key)) + ":")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column is-4 p-0 font-weight-light"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.measurementToFixed(measurement)
                                    ) +
                                      " " +
                                      _vm._s(_vm.measurementUnit(key)) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column is-4 p-0 font-weight-light"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.convertMeasurement(
                                          key,
                                          measurement,
                                          _vm.hazard.measurement_unit
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.measurementUnit(key, "il")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "technical-information" }, [
            _c(
              "ul",
              { staticClass: "rows t-navy fs-18" },
              [
                _vm._l(_vm.hazard.meta_keys, function(meta) {
                  return [
                    _vm.metaValue(meta)
                      ? _c(
                          "li",
                          { staticClass: "row px-2 py-12px t-navy w-100" },
                          [
                            _c("div", { staticClass: "column is-4 p-0" }, [
                              _vm._v(_vm._s(meta.name) + ":")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "column is-7 p-0 font-weight-light"
                              },
                              [_vm._v(_vm._s(_vm.metaValue(meta)))]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03d6b7fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d6b7fd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/TechnicalInformation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-03d6b7fd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/TechnicalInformation.vue
// module chunks = 0 1